import { useMemo } from 'react';
import {
  FilterGroupingEnum,
  useTaskCompletionsIdsQuery,
} from '@lib/graphql-common';
import { SelectOption } from '@lib/components/Select/types';

type Args = {
  interventionId?: string | null;
  taskGroupKey?: string | null;
  skip?: boolean;
};

// Completions already covered by an existing Intervention, as Completions
// field options for its edit form. `onlyIds` returns the full id list in one
// request (no pagination) — enough, since the field only shows "Selected (N)".
export default function useInterventionLinkedCompletions({
  interventionId,
  taskGroupKey,
  skip,
}: Args) {
  const { data, loading } = useTaskCompletionsIdsQuery({
    variables: {
      groupKey: taskGroupKey || '',
      filters: [
        {
          interventionId: {
            grouping: FilterGroupingEnum.And,
            predicate: { eq: interventionId },
          },
        },
      ],
    },
    skip: skip || !interventionId || !taskGroupKey,
  });

  const options = useMemo<SelectOption[]>(
    () => (data?.data.collection || []).map(({ id }) => ({ value: id })),
    [data],
  );

  return { options, loading };
}
